module.exports = __webpack_public_path__ + "static/media/copy-page.95cb13cd.svg";